import { useEffect } from 'react';
import { TrackingEvents, useTrackingDispatch } from 'modules/analytics';
import { LoginScreen } from 'modules/login';

export const LoginPage = () => {
  const dispatch = useTrackingDispatch();

  useEffect(() => {
    dispatch({
      type: TrackingEvents.HOME_PAGE_VIEWED
    });
  }, [dispatch]);

  return <LoginScreen />;
};
